import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import router from "@/router";
import SidebarShortPanel from "./SidebarShortPanel.vue";
import { NavigationItem } from "@/types";
import { UserRoles } from "@/enums/UserRoles";
import { EstateInterface } from "@/types/EstateInterface";
import store from "@/store";
import getUserRole from "@/helpers/getUserRole";
import isReportsRoute from "@/helpers/analytics/isReportsRoute";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  props: {
    navigation: {},
    isActiveBurger: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const activeRoute = ref("");
const { isSalesPersonRole } = getUserRole();
const activeEoiCounter = computed(() => {
  return store.state.eoi.activeEoiCounter;
});

const unwatchedLeadsCounter = computed(() => {
  return store.state.contact.unwatchedLeadsCounter;
});

const pendingInitialCounter = computed(() => {
  return store.state.initialHold.pendingInitialHoldsCounter;
});

const getNormalizedNavigation = computed(() => {
  const normalizedNav = props.navigation.map((item) => {
    if (item.slug === "eoi") {
      item.counter = activeEoiCounter.value;
    }
    if (item.slug === "leads") {
      item.counter = unwatchedLeadsCounter.value;
    }
    if (item.slug === "initial-hold") {
      item.counter = pendingInitialCounter.value;
    }
    return item;
  });

  if (isSalesPersonRole.value) {
    return normalizedNav.filter((item) => item.slug !== "listing");
  }
  return normalizedNav;
});
const navTitle = computed(() => {
  const { fullPath } = router.currentRoute.value;
  if (fullPath.startsWith("/landowner/profile")) {
    return "Settings";
  }
  if (fullPath.startsWith("/admin")) {
    return "Admin";
  }
  return "";
});
const selectedEstate = computed(() => {
  return store.state.user.landownerEstates.find(
    (estate) => estate._id === store.state.user.selectedEstateId
  );
});

function getActiveRouteClass(item: NavigationItem) {
  const path = getSlugPath();
  return item.slug === path.split("/")[1] ? "active" : "";
}

function getSlugPath() {
  const { meta, fullPath } = router.currentRoute.value;
  if (
    meta?.access &&
    (meta.access as string[]).includes(UserRoles.SUPER_ADMIN)
  ) {
    return fullPath.replace("/admin", "");
  }
  if (fullPath.startsWith("/landowner/profile")) {
    return fullPath.replace("/landowner/profile", "");
  }
  return fullPath;
}

function onNavigationLink(item: NavigationItem) {
  activeRoute.value = item.slug;
}

const __returned__ = { props, activeRoute, isSalesPersonRole, activeEoiCounter, unwatchedLeadsCounter, pendingInitialCounter, getNormalizedNavigation, navTitle, selectedEstate, getActiveRouteClass, getSlugPath, onNavigationLink, computed, ref, get router() { return router }, SidebarShortPanel, get NavigationItem() { return NavigationItem }, get UserRoles() { return UserRoles }, get EstateInterface() { return EstateInterface }, get store() { return store }, get getUserRole() { return getUserRole }, get isReportsRoute() { return isReportsRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})